import { VariantProps, cva } from "class-variance-authority";

export const buttonVariants = cva(
  [
    "font-semibold",
    "text-nowrap",
    "transition-all",
    "relative",
    "cursor-pointer",
    "disabled:bg-gray-300 ",
    "gap-2",
    "disabled:cursor-not-allowed",
    "flex items-center",
    "justify-center",
    // Hybrid pattern: border for visible outline, ring for focus indicator
    "border-2 border-transparent",
    "font-medium",
    "ring-0",
    "focus:ring-[length:var(--button-ring-width-focus)] focus:ring-button-ring-focus",
    "outline-none",
  ],
  {
    variants: {
      vSize: {
        sm: "py-[0.37rem] px-4 text-xs h-[1.9375rem] rounded-button-sm",
        md: "py-2 px-4 text-sm h-[2.375rem] rounded-button-md",
        lg: "px-2 sm:px-4 text-sm sm:text-base h-[2.375rem] sm:h-[3rem] rounded-button-md sm:rounded-button-lg",
      },
      vStyle: {
        solid: ["text-white"],
        // Outline buttons: border provides the visible outline (color set by compound variants)
        outline: ["focus:ring-offset-2"],
      },
      vColor: {
        primary: [" "],
        secondary: [],
        success: [],
        danger: [],
      },
      loading: {
        true: "",
        false: "",
      },
    },
    compoundVariants: [
      // outline
      {
        vColor: "primary",
        vStyle: "outline",
        className: [
          "border-primary-600 text-primary-600",
          "hover:bg-primary-500 hover:text-white",
          "active:bg-primary-600",
        ],
      },
      {
        vColor: "secondary",
        vStyle: "outline",
        className: [
          "border-secondary-600 text-secondary-600",
          "hover:bg-secondary-500 hover:text-white",
          "active:bg-secondary-600",
        ],
      },
      {
        vColor: "danger",
        vStyle: "outline",
        className: [
          "border-error-600 text-error-600",
          "hover:bg-error-500 hover:text-white",
          "active:bg-error-600",
        ],
      },
      {
        vColor: "success",
        vStyle: "outline",
        className: [
          "border-success-600 text-success-600",
          "hover:bg-success-500 hover:text-white",
          "active:bg-success-600",
        ],
      },
      // solid
      {
        vColor: "primary",
        vStyle: "solid",
        className: [
          "bg-primary-500",
          "hover:bg-primary-600",
          "active:bg-primary-700",
          "text-white",
        ],
      },
      {
        vColor: "secondary",
        vStyle: "solid",
        className: [
          "bg-secondary-500",
          "hover:bg-secondary-600",
          "active:bg-secondary-700",
          "text-white",
        ],
      },
      {
        vColor: "danger",
        vStyle: "solid",
        className: [
          "bg-error-500",
          "hover:bg-error-600",
          "active:bg-error-700",
          "text-white",
        ],
      },
      {
        vColor: "success",
        vStyle: "solid",
        className: [
          "bg-success-500",
          "hover:bg-success-600",
          "active:bg-success-700",
          "text-white",
        ],
      },
      {
        loading: true,
        vColor: "primary",
        vStyle: "solid",
        className: "!bg-gray-400",
      },
      {
        loading: true,
        vColor: "secondary",
        vStyle: "solid",
        className: "!bg-gray-400",
      },
      {
        loading: true,
        vColor: "success",
        vStyle: "solid",
        className: "!bg-gray-400",
      },
      {
        loading: true,
        vColor: "danger",
        vStyle: "solid",
        className: "!bg-gray-400",
      },
    ],
    defaultVariants: {
      vSize: "md",
      vColor: "primary",
      vStyle: "solid",
    },
  },
);
export type ButtonVariantProps = VariantProps<typeof buttonVariants>;
